import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de281153b1c854/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/app/[locale]/branchen/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/node_modules/next/dist/client/link.js");
